/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document[_ngcontent-%COMP%] {\n    max-width: 1080px;\n    background:white;\n}\n\n.doc-img[_ngcontent-%COMP%] {\n    max-width: 890px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\nol[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] {\n    margin-left: 2em;\n    font-style: italic;\n    font-weight: bold;\n}\nol[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > p[_ngcontent-%COMP%] {\n    font-style: italic;\n    font-weight: bold;\n}\n\nul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] {\n    margin-left: 4em;\n}\n\nsection[_ngcontent-%COMP%] > p[_ngcontent-%COMP%] { margin-left: 4em;}"];
export { styles as styles };



// WEBPACK FOOTER //
// /build/client-cms/src/app/dashboard/dashboard.component.css.shim.ngstyle.js.pre-build-optimizer.js